import { combineEpics } from 'redux-observable';

import { recordConsentEpic } from './record-consent.epic';

const legalConsentEpic = combineEpics(recordConsentEpic);

export { legalConsentEpic };
